import { render } from "./TheVehicleOngoingTrips.vue?vue&type=template&id=131e6925"
import script from "./TheVehicleOngoingTrips.vue?vue&type=script&lang=js"
export * from "./TheVehicleOngoingTrips.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__